module.exports = __webpack_public_path__ + "img/ep-montgolfiere.eee65225.jpg";